import React, { useEffect, useState } from 'react'
import FilterBarAndCards from '../../Components/FilterBarAndCards/FilterBarAndCards';
import CenterStage from '../../Components/CenterStage/CenterStage';
import imgStage from '../../assets/Associations/stage.jpg'
import imgCertified from '../../assets/Associations/CertifiedAnd Reliability.jpg'
import { Col, Container, Row } from 'react-bootstrap';
import ImageCard from '../../Components/ImageCard/ImageCard';
import SectionHeader from '../../Components/SectionHeader/SectionHeader';

const Associations = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on component mount
    }, []);
    const [activeFilter, setActiveFilter] = useState('all'); // State to track active filter


    const filterData = [
        { label: 'Show all', value: 'all', isSelected: activeFilter === 'all' },
        { label: 'Germany', value: 'Deutschland', isSelected: activeFilter === 'Deutschland' },
        { label: 'Europe', value: 'Europa', isSelected: activeFilter === 'Europa' },
        { label: 'America', value: 'Amerika', isSelected: activeFilter === 'Amerika' },
        { label: 'Africa', value: 'Afrika', isSelected: activeFilter === 'Afrika' },
        { label: 'Asia', value: 'Asien', isSelected: activeFilter === 'Asien' },
    ];

    const cardData = [
        {
            parent: 'Deutschland',
            title: 'BBI – Federal Association of Bausch Machine Companies e. V.',
            description:
                'The Federal Association of Construction Machinery, Construction Equipment and Industrial Machinery Companies is a nationally and internationally active trade association consisting primarily of medium-sized companies.',
            tag: 'Germany',
            link: 'https://www.bbi-online.org',
        },
        {
            parent: 'Deutschland',
            title: 'BWE – Bundesverband WindEnergie eV',
            description:
                'With over 20,000 members, the German Wind Energy Association is one of the world\'s largest associations for renewable energies. Its goal: sustainable, efficient expansion of wind energy.',
            tag: 'Germany',
            link: 'https://www.wind-energie.de',
        },
        {
            parent: 'Deutschland',
            title: 'ECC Club – Networking for E-Commerce and Cross-Channel',
            description:
                'Integrated into the IFH KÖLN, the ECC KÖLN offers the appropriate transfer of success- and business-relevant know-how into the world of digital commerce via channels such as events, lectures and web talks.',
            tag: 'Germany',
            link: 'https://www.ifhkoeln.de/ecc-club/',
        },
        {
            parent: 'Deutschland',
            title: 'DA – German Demolition Association eV',
            description:
                'The German Demolition Association eV has been the leading business and entrepreneur association in the demolition industry in Germany since 1951 and the largest national association in the demolition industry in Europe.',
            tag: 'Germany',
            link: 'https://www.deutscher-abbruchverband.de',
        },
        {
            parent: 'Deutschland',
            title: 'DWT – GERMAN SOCIETY FOR DEFENSE TECHNOLOGY eV',
            description:
                'The German Society for Defense Technology is a neutral dialogue and information platform in the field of tension between the Bundeswehr, research, business, politics and society.',
            tag: 'Germany',
            link: 'https://www.dwt-sgw.de',
        },
        {
            parent: 'Deutschland',
            title: 'German Showmen\'s Association eV',
            description:
                'The German Showmen\'s Association eV, based in Berlin, is the top professional organization for the showmen\'s industry and amusement parks in Germany. The DSB has over 4,200 full members.',
            tag: 'Germany',
            link: 'https://www.dsbev.de',
        },
        {
            parent: 'Deutschland',
            title: 'TH Ulm – Competence Center Hydraulics Ulm',
            description:
                'Ulm University of Applied Sciences conducts research and teaches on current topics. Cooperations in the Department of Mechanical Engineering and Automotive Engineering with well-known companies in the region enable the optimal combination of theory and application.',
            tag: 'Germany',
            link: 'https://studium.hs-ulm.de/de/org/ifs/Seiten/Kompetenzzentrum_Hydraulik.aspx',
        },
        {
            parent: 'Deutschland',
            title: 'OAV – German Asia-Pacific Business Association',
            description:
                'The East Asian Association eV offers companies with experience in Asia and newcomers the opportunity to exchange experiences across industries and a comprehensive range of practical services.',
            tag: 'Germany',
            link: 'https://www.oav.de',
        },
        {
            parent: 'Deutschland',
            title: 'PUU – Partnership Environmental Companies',
            description:
                'The Environmental Company Partnership is a network with the aim of combining economic success, social responsibility and the protection of the environment and resources in an exemplary manner.',
            tag: 'Germany',
            link: 'https://www.umwelt-unternehmen.bremen.de',
        },
        {
            parent: 'Deutschland',
            title: 'VDBUM – Association of the Construction Industry, Environmental and Mechanical Engineering eV',
            description:
                'The Association of the Construction Industry, Environmental and Mechanical Engineering eV is a professional interest group for all questions of everyday professional life and a forum for construction professionals.',
            tag: 'Germany',
            link: 'https://vdbum.de/startseite/',
        },
        {
            parent: 'Deutschland',
            title: 'VDMA – Association of German Mechanical and Plant Engineering eV',
            description:
                'With over 3,400 members, the VDMA is the largest network organization and an important mouthpiece for mechanical engineering in Germany and Europe. The association represents the common interests of the industry.',
            tag: 'Germany',
            link: 'https://www.vdma.org',
        },
        {
            parent: 'Deutschland',
            title: 'Association of German Ship Suppliers eV',
            description:
                'The federal association is an interest group, network and forum for around 130 members, including ship chandlers, producers, wholesalers, suppliers, logisticians and others in the ship equipment sector.',
            tag: 'Germany',
            link: 'https://shipsuppliers.de',
        },
        {
            parent: 'Deutschland',
            title: 'WVIS – Economic Association for Industrial Services eV',
            description:
                'The Economic Association for Industrial Services eV is a key factor for competitive industrial locations with a market volume of more than 20 billion euros in Germany alone.',
            tag: 'Germany',
            link: 'http://www.wvis.eu',
        },
        {
            parent: 'Deutschland',
            title: 'VTH – Association of Technical Trade',
            description:
                'The VTH is the only trade association for the technical trade sector and the professional association for technical dealers in Germany, Austria and Switzerland.',
            tag: 'Germany',
            link: 'https://www.vth-verband.de',
        },
        {
            parent: 'Europa',
            title: 'AGORIA',
            description:
                'With more than 2,000 technology companies from the manufacturing, digital and telecommunications sectors, Agoria is the largest association within the Confederation of Belgian Companies.',
            tag: 'Belgium',
            link: 'https://www.agoria.be/',
        },
        {
            parent: 'Europa',
            title: 'InduMotion',
            description:
                'InduMotion is the association for companies specializing in industrial automation and drive technology and operating on the Belgian market as manufacturers, official importers or distributors.',
            tag: 'Belgium',
            link: 'https://www.indumotion.be/',
        },
        {
            parent: 'Europa',
            title: 'IMPA – International Marine Purchasing Association',
            description:
                'IMPA represents around 1,000 members from the maritime purchasing and supplier sector who are committed to the continuous improvement and development of the industry.',
            tag: 'Great Britain',
            link: 'https://impa.net',
        },
        {
            parent: 'Europa',
            title: 'German-Croatian Chamber of Industry and Commerce',
            description:
                'The largest bilateral economic organization in Croatia offers a network of currently over 330 registered companies from German, Croatian and international business circles.',
            tag: 'Croatia',
            link: 'https://kroatien.ahk.de/',
        },
        {
            parent: 'Europa',
            title: 'German-Portuguese Chamber of Industry and Commerce',
            description:
                'The AHK Portugal promotes cooperation between German and Portuguese companies and supports them in establishing and expanding their business relations in both countries.',
            tag: 'Portugal',
            link: 'https://www.ccila-portugal.com',
        },
        {
            parent: 'Europa',
            title: 'GOP – Society for Fluid Technology',
            description:
                'The Society for Fluid Technology is a Swiss association of around 80 manufacturing and trading companies with the aim of promoting progress in fluid technology.',
            tag: 'Switzerland',
            link: 'https://www.gop-verband.ch',
        },
        {
            parent: 'Amerika',
            title: 'German-Brazilian Chamber of Industry and Commerce',
            description:
                'The German-Brazilian Chamber of Industry and Commerce in São Paulo (AHK São Paulo) is part of the worldwide network of German Chambers of Commerce Abroad (AHK) with 140 locations in 92 countries.',
            tag: 'Brazil',
            link: 'https://www.ahkbrasilien.com.br/',
        },
        {
            parent: 'Amerika',
            title: 'NAHAD – The Association for Hose & Accessories Distribution',
            description:
                'The association represents leading manufacturers, dealers and service providers of hose lines and accessories in North America. Its own training center offers numerous training courses.',
            tag: 'USA',
            link: 'https://www.nahad.org/',
        },
        {
            parent: 'Amerika',
            title: 'NFPA – National Fluid Power Association',
            description:
                'The National Fluid Power Association (NFPA) is the only trade association focused exclusively on fluid power, with members representing the entire fluid power supply chain.',
            tag: 'USA',
            link: 'https://www.nfpa.com',
        },
        {
            parent: 'Afrika',
            title: 'SAFPA – South African Fluid Power Association',
            description:
                'The South African Fluid Power Association (SAFPA) aims to improve standards and norms in the pneumatic and hydraulic industry and to promote mutual exchange.',
            tag: 'South Africa',
            link: 'https://www.safpa.org.za/',
        },
        {
            parent: 'Asien',
            title: 'UTCC – The Thai Chamber of Commerce',
            description:
                'Since 1923, the Thai Chamber of Commerce has been promoting the interests of the Thai economy across all sectors through events, initiatives and trade fairs, as well as relations with foreign countries.',
            tag: 'Thailand',
            link: 'https://www.thaichamber.org/',
        },
    ];

    // Function to handle filter changes
    const setFilter = (filterValue) => {
        setActiveFilter(filterValue);
    };

    // Filter the cards based on activeFilter
    const filteredCards = cardData.filter(card => {
        if (activeFilter === 'all') {
            return true; // Show all cards
        }
        return card.parent === activeFilter;
    });

    return (
        <div>
            <CenterStage imageSrc={imgStage} title={"COMMITTED AND WELL CONNECTED"}
                paragraph={"HANSA-FLEX AG maintains memberships in numerous associations at home and abroad. We are involved in industry associations for fluid technology and in leading organizations in various industries. As part of our association work, we contribute our perspectives and expertise on various topics and gain access to valuable information that we can pass on to our customers and partners."} />
            <FilterBarAndCards
                filterData={filterData}
                cardData={filteredCards}
                setFilter={setFilter}
            />

            <SectionHeader title={"LEARN MORE ABOUT HANSA-FLEX"} />
            <Container className="custom-container">
                <Row>
                    <Col sm={12} md={6} lg={4}><ImageCard image={imgCertified} learnMoreLink={"/certificates"}
                        title="Certified reliability and quality"
                        desc={"HANSA ‑FLEX AG has ISO-certified management systems for quality management, environmental management and occupational safety."} /></Col>

                    <Col sm={12} md={6} lg={4}><ImageCard image={imgCertified} learnMoreLink={"/approvals"}
                        title="Tested and approved"
                        desc={"HANSA-FLEX has a large number of approvals and supplier qualifications from renowned associations, authorities and classification societies."} /></Col>

                </Row>
            </Container>
        </div>
    );
};

export default Associations